import { ga4Push } from '../../../ga4/ga4-utilities';
import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';
import Localization from '../../../other/localization';
import { GrecaptchaV2 } from '../../../other/grecaptcha/grecaptcha-v2';
import { hideErrorMessage } from '../../../components/validator-helper';

/**
 * Promóciós hírlevél form validáció.
 *
 * @author Csernai Zsolt
 */
function PromotionNewsletterForm() {
    const formId = 'promotionNewsletterForm';
    const form = $(`#${formId}`);
    const validator = AbstractValidator(formId);
    const validatorOptions = AbstractValidatorOptions();
    const localization = new Localization();
    const greCaptchaV2 = new GrecaptchaV2();
    const recaptchaErrorElement = $('#promotionCaptchaError');

    function initMeasurement() {
        const sourceName = (
            form.closest('div.modal div.modal-lg').length > 0
            ? 'popup'
            : 'landingPage'
        );
        const promotionPrefix = form.data('gaEventLabelPrefix');
        const subscribeType = `${promotionPrefix}_${sourceName}`;
        ga4Push({
            event: 'newsletterSubscribe',
            subscribeType,
        });
    }

    function init() {
        validatorOptions.focusInvalid = false;
        validatorOptions.showToastMessagesOnError = false;
        validatorOptions.scrollToFirstError = false;
        validatorOptions.onclick = (element) => {
            const elementObject = $(element);
            if (elementObject.attr('id') === 'accept_eula') {
                hideErrorMessage(elementObject);
            }
        };
        validatorOptions.errorElement = 'label';
        validatorOptions.errorPlacement = (error, element) => {
            $(element)
            .closest('.form-control-wrapper')
            .append(error);
        };

        validatorOptions.messages = {
            newsletter_firstname: {
                required: localization.getMessage('validation_first_name_required'),
            },
            newsletter_lastname: {
                required: localization.getMessage('validation_last_name_required'),
            },
            newsletter_email: {
                required: localization.getMessage('validation-message-email-required'),
            },
        };

        validator.init(
            {
                newsletter_firstname: {
                    maxlength: 60,
                    required: true,
                },
                newsletter_lastname: {
                    maxlength: 60,
                    required: true,
                },
                newsletter_email: {
                    required: true,
                    customEmail: true,
                },
                accept_privacy_policy: {
                    required: true,
                },
            },
            validatorOptions,
        );

        greCaptchaV2.init('promotionSubscriptionCaptcha');
        greCaptchaV2.setErrorContainer(recaptchaErrorElement);

        form
        .on('success', () => {
            initMeasurement();

            $('.landing-page-content')
            .find('.subscribed-message,.unsubscribed-form')
            .addClass('d-none')
            .end()
            .find('.subscribe-messages,.unsubscribed-message')
            .removeClass('d-none');
        })
        .on('submitStart', (event) => {
            $(event.currentTarget).find('.btn-campaign').attr('disabled', 'disabled');
        })
        .on('submitFinished', (event) => {
            $(event.currentTarget).find('.btn-campaign').removeAttr('disabled');
        })
        .on('invalidForm', () => {
            greCaptchaV2.reset();
        })
        .on('error', (event, errors) => {
            greCaptchaV2.reset();
            if (Object.keys(errors).indexOf('g-recaptcha-response') > -1) {
                recaptchaErrorElement.html(Object.values(errors)[0]);
            }
        });

        // Facebook és Google feliratkozás mérése
        form.find('.social-promotion-button').on('click', () => {
            initMeasurement();
        });
    }

    return {
        init,
    };
}

export default PromotionNewsletterForm;
